/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 56dd570fbfc8d3aff994873684002621be61cd7e725a31920f7f4b04f886fb11
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './MenuOptionTertiary.style'

type MenuOptionTertiaryOwnProps = {
  className?: string
  aiPowered?: boolean
  icon?: React.ReactNode
  subtext?: React.ReactNode
  title: string
  trailing?: React.ReactNode
  variant?: 'default' | 'severe'
}

export type MenuOptionTertiaryProps = MenuOptionTertiaryOwnProps & Omit<ComponentProps<'button'>, keyof MenuOptionTertiaryOwnProps>

function MenuOptionTertiary(props: MenuOptionTertiaryProps): ReactElement {
  const {
    children,
    className = '',
    aiPowered = false,
    icon,
    subtext,
    title,
    trailing,
    variant = 'default',
    ...rest
  } = props

  return (
    <button
      className={cn('MenuOptionTertiary', className, variant, { aiPowered })}
      css={style}
      {...rest}
      type={rest.type ?? 'button'}
      role='menuitem'
    >
      {icon}
      {children}
      {subtext}
      {title}
      {trailing}
    </button>
  )
}

export default MenuOptionTertiary
